import React, { useEffect, useState } from 'react';

import S from './AttendeesCount.styles';

type Props = {
  showLabel?: boolean;
  numOfAttendees: number;
  attendeesChanged(number): void;
  min?: number;
  max?: number | null;
};

const AttendeesCount = ({
  showLabel = true,
  numOfAttendees,
  attendeesChanged,
  min,
  max,
}: Props) => {
  const [attendeesCount, setAttendeesCount] = useState<number>(numOfAttendees);

  useEffect(() => {
    attendeesChanged(attendeesCount);
  }, [attendeesChanged, attendeesCount]);

  return (
    <S.FlexRow>
      {showLabel && <S.StyledControlLabel>Attendees:</S.StyledControlLabel>}
      <S.Col>
        <S.StyledButton
          onClick={() =>
            setAttendeesCount(prev => (prev <= (min || 1) ? prev : prev - 1))
          }
        >
          <i className='fa fa-minus' aria-hidden='true' />
        </S.StyledButton>
        {numOfAttendees}
        <S.StyledButton
          onClick={() =>
            setAttendeesCount(prev => (max && prev >= max ? prev : prev + 1))
          }
        >
          <i className='fa fa-plus' aria-hidden='true' />
        </S.StyledButton>
      </S.Col>
    </S.FlexRow>
  );
};

export default AttendeesCount;
